/**
 * メンテナンス状態をチェックして、メンテナンス中なら専用ページを表示するラッパー
 */

import React, { useEffect, useState } from "react";
import { MaintenancePage } from "../pages/MaintenancePage";

// メンテナンス状態をチェックするAPI（公開用・認証不要）
const checkMaintenanceStatus = async (): Promise<boolean> => {
  try {
    // WebClient経由でメンテナンス状態を取得
    const response = await fetch("/api/web/maintenance/status");
    if (!response.ok) {
      // エラー時はメンテナンス中とみなさない（サイトを表示）
      console.warn(`メンテナンス状態の取得に失敗: ${response.status} ${response.statusText}`);
      return false;
    }
    const data = await response.json();
    return data.isMaintenanceMode === true;
  } catch (error) {
    console.error("メンテナンス状態の確認に失敗:", error);
    // エラー時はメンテナンス中とみなさない（サイトを表示）
    return false;
  }
};

interface MaintenanceGuardProps {
  children: React.ReactNode;
}

export const MaintenanceGuard: React.FC<MaintenanceGuardProps> = ({
  children,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    const check = async () => {
      const status = await checkMaintenanceStatus();
      setIsMaintenance(status);
      setIsLoading(false);
    };
    check();
  }, []);

  // ローディング中は何も表示しない（一瞬なのでスピナーは不要）
  if (isLoading) {
    return null;
  }

  // メンテナンス中はメンテナンスページを表示
  if (isMaintenance) {
    return <MaintenancePage />;
  }

  // 通常時は子コンポーネントを表示
  return <>{children}</>;
};
